import Vue from 'vue';
import Router from 'vue-router';
import Userauth from '../pages/auth/js/index';

import Body from '../components/body';

/* Error Pages */
import Error400 from '../pages/errors/error_400';
import Error401 from '../pages/errors/error_401';
import Error403 from '../pages/errors/error_403';
import Error404 from '../pages/errors/error_404';
import Error500 from '../pages/errors/error_500';
import Error503 from '../pages/errors/error_503';

/* Dashboards */
//import Default from '../pages/dashboard/default';
//import Ecommerce from '../pages/dashboard/ecommerce';

/* sample page */
import SamplePage from '../pages/sample_page';
import TermOfUse from '../pages/term_of_use';

/* User Profile */
//import UserProfile from '../pages/users/profile';
//import UserEditProfile from '../pages/users/edit-profile';
//import UserCards from '../pages/users/cards';

/* Authentication */
import LoginOne from '../pages/auth/login_one';
import RegisterImage from '../pages/auth/register_image';
import Verify from '../pages/auth/verify';
import ForgetPassword from '../pages/auth/forget_password';
import ResetPassword from '../pages/auth/reset_password';

/* Admin */
import User from '../pages/admin/user-management';
import Server from '../pages/admin/server';
import RulesSetting from '../pages/admin/rules-setting.vue'
import BotTraining from '../pages/admin/bot-training.vue';

/* CCP */
import QueueManagement from '../pages/ccp/queue-management.vue'
import QueueReport from '../pages/ccp/report/queue-report.vue'
import Desktop from '../pages/ccp/agent-desktop';
import Folder from '../pages/ccp/template-folder';
import Template from '../pages/ccp/template';
import Queue from '../pages/ccp/queue';
import Detail from '../pages/ccp/report/detail';
import Daily from '../pages/ccp/report/daily';
import Month from '../pages/ccp/report/month';
import Priority from '../pages/ccp/priority';
/* Beacon */
import Case from '../pages/beacon/case-management';
import NewCase from '../pages/beacon/add-new-case';
import Company from '../pages/beacon/company';
import Member from '../pages/beacon/member';
import Annoucement from '../pages/beacon/annoucement';
import Application from '../pages/beacon/application';
import Category from '../pages/beacon/category';
import Group from '../pages/beacon/group';
import Rule from '../pages/beacon/rule';
import Symtom from '../pages/beacon/symtom';
import ReportCase from '@/pages/beacon/report/report-case.vue';
import ReportSms from '@/pages/beacon/report/report-sms.vue';

// component

Vue.use(Router);

const routes = [
  {
    path: '',
    redirect: {
      name: 'default',
    },
    component: Body,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/',
    component: Body,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/',
        name: 'default',
        component: SamplePage,
        meta: {
          title: 'Welcome | Cloud Centric',
          requiresAuth: true,
        },
      },
      {
        path: '/term_of_use',
        name: 'default',
        component: TermOfUse,
        meta: {
          title: 'Term of use | Cloud Centric',
          requiresAuth: false,
        },
      },
      {
        path: '/ccp/desktop',
        name: 'desktop',
        component: Desktop,
        meta: {
          title: 'Agent Desktop | Cloud Centric',
          requiresAuth: true,
          role: ['agent', 'admin'],
          module: ['ccp'],
        },
      },
      {
        path: '/ccp/priority',
        name: 'desktop',
        component: Priority,
        meta: {
          title: 'Priority | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['ccp'],
        },
      },
      {
        path: '/ccp/folder',
        name: 'email template folder',
        component: Folder,
        meta: {
          title: 'Email Template Folder | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['ccp'],
        },
      },
      {
        path: '/ccp/template',
        name: 'email template',
        component: Template,
        meta: {
          title: 'Email Template | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['ccp'],
        },
      },

      {
        path: '/ccp/queue',
        name: 'email queue',
        component: Queue,
        meta: {
          title: 'Email Queue | Cloud Centric',
          requiresAuth: true,
          role: ['admin', 'agent'],
          module: ['ccp'],
        },
      },
      {
        path: '/ccp/detail',
        name: 'detail',
        component: Detail,
        meta: {
          title: 'Report Detail | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['ccp'],
        },
      },
      {
        path: '/ccp/daily',
        name: 'daily',
        component: Daily,
        meta: {
          title: 'Report Daily | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['ccp'],
        },
      },
      {
        path: '/ccp/monthly',
        name: 'monthly',
        component: Month,
        meta: {
          title: 'Report Monthly | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['ccp'],
        },
      },
    ],
  },
  {
    path: '/pages',
    component: Body,
    children: [
      {
        path: '/beacon/report/sms',
        name: 'Sms',
        component: ReportSms,
        meta: {
          title: 'Sms | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['beacon'],
        },
      },
      {
        path: '/beacon/report/case',
        name: 'Case',
        component: ReportCase,
        meta: {
          title: 'Case | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['beacon'],
        },
      },
      {
        path: '/beacon/case-management',
        name: 'Case',
        component: Case,
        meta: {
          title: 'Case Management | Cloud Centric',
          requiresAuth: true,
          role: ['admin', 'agent'],
          module: ['beacon'],
        },
      },
      {
        path: '/beacon/new',
        name: 'Create Beacon',
        component: NewCase,
        meta: {
          title: 'Create Case | Cloud Centric',
          requiresAuth: true,
          role: ['admin', 'agent'],
          module: ['beacon'],
        },
      },
      {
        path: '/user-management',
        name: 'User',
        component: User,
        meta: {
          title: 'Create User Management | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['beacon', 'ccp'],
        },
      },
      {
        path: '/queue-management',
        name: 'QueueManagement',
        component: QueueManagement,
        meta: {
          title: 'Queue Management | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          // module: ['beacon', 'ccp'],
        },
      },
      {
        path: '/report/queue',
        name: 'QueueReport',
        component: QueueReport,
        meta: {
          title: 'Queue Report | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          // module: ['beacon', 'ccp'],
        },
      },
      {
        path: '/rules-management',
        name: 'RulesManagement',
        component: RulesSetting,
        meta: {
          title: 'Rules Management | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          // module: ['beacon', 'ccp'],
        },
      },
      {
        path: '/setting/server',
        name: 'Server',
        component: Server,
        meta: {
          title: 'Server Setting | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['ccp'],
        },
      },
      {
        path: '/beacon/application',
        name: 'Application',
        component: Application,
        meta: {
          title: 'Application | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['beacon'],
        },
      },
      {
        path: '/beacon/annoucement',
        name: 'Annoucement',
        component: Annoucement,
        meta: {
          title: 'Annoucement | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['beacon'],
        },
      },
      {
        path: '/beacon/category',
        name: 'Category',
        component: Category,
        meta: {
          title: 'Category | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['beacon'],
        },
      },
      {
        path: '/beacon/company',
        name: 'Company',
        component: Company,
        meta: {
          title: 'Company | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['beacon'],
        },
      },
      {
        path: '/beacon/group',
        name: 'Group',
        component: Group,
        meta: {
          title: 'Group | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['beacon'],
        },
      },
      {
        path: '/beacon/member',
        name: 'Member',
        component: Member,
        meta: {
          title: 'Member | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['beacon'],
        },
      },
      {
        path: '/beacon/rule',
        name: 'Rule',
        component: Rule,
        meta: {
          title: 'Rule | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['beacon'],
        },
      },
      {
        path: '/beacon/symptom',
        name: 'Symptom',
        component: Symtom,
        meta: {
          title: 'Symptom | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['beacon'],
        },
      },
      {
        path: '/setting/bot-training',
        name: 'BotTraining',
        component: BotTraining,
        meta: {
          title: 'Bot Training | Cloud Centric',
          requiresAuth: true,
          role: ['admin'],
          module: ['ccp'],
        },
      },
    ],
  },
  {
    path: '/error-400',
    name: 'Error400',
    component: Error400,
    meta: {
      title: 'Error400 | Cloud Centric',
    },
  },
  {
    path: '/error-401',
    name: 'Error401',
    component: Error401,
    meta: {
      title: 'Error401 | Cloud Centric',
    },
  },
  {
    path: '/error-403',
    name: 'Error403',
    component: Error403,
    meta: {
      title: 'Error403 | Cloud Centric',
    },
  },
  {
    path: '/error-404',
    name: 'Error404',
    component: Error404,
    meta: {
      title: 'Error404 | Cloud Centric',
    },
  },
  {
    path: '/error-500',
    name: 'Error500',
    component: Error500,
    meta: {
      title: 'Error500 | Cloud Centric',
    },
  },
  {
    path: '/error-503',
    name: 'Error503',
    component: Error503,
    meta: {
      title: 'Error503 | Cloud Centric',
    },
  },
  {
    path: '/login',
    name: 'LoginOne',
    component: LoginOne,
    meta: {
      title: 'LoginOne | Cloud Centric',
      requiresAuth: false,
    },
  },
  {
    path: '/register',
    name: 'RegisterImage',
    component: RegisterImage,
    meta: {
      title: 'RegisterImage | Cloud Centric',
    },
  },
  {
    path: '/verify_email',
    name: 'Verify',
    component: Verify,
    meta: {
      title: 'Verify | Cloud Centric',
    },
  },
  {
    path: '/forgetpassword',
    name: 'ForgetPassword',
    component: ForgetPassword,
    meta: {
      title: 'ForgetPassword | Cloud Centric',
    },
  },
  {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      title: 'ResetPassword | Cloud Centric',
    },
  },


  // Redirect to 404 page, if no match found
  /*{
    path: '*',
    redirect: '/error-404',
  },*/
];

const router = new Router({
  routes,
  base: process.env.BASE_URL,
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  let status_ccp = false;
  let status_beacon = false;
  if (to.meta.module != undefined) {
    let userinfo = localStorage.getItem('userinfo');
    userinfo = JSON.parse(userinfo);
    //console.log("userinfo",userinfo);
    if (userinfo==null) {
      router.push('/login').catch();
      return;
    }
    for (let i = 0; i < to.meta.module.length; i++) {
      if (to.meta.module[i] == 'beacon') {
        if (userinfo.role_beacon == undefined) {
          status_beacon = false;
        }
        status_beacon = to.meta.role.includes(userinfo.role_beacon);
      } else if (to.meta.module[i] == 'ccp') {
        if (userinfo.role_ccp == undefined) {
          status_ccp = false;
        }
        status_ccp = to.meta.role.includes(userinfo.role_ccp);
      }
    }
  } else {
    status_ccp = true;
    status_beacon = true;
  }
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  let isAuthenticated = Userauth.isAuthenticated();
  if ((requiresAuth === true && isAuthenticated === true) || requiresAuth === false) {
    if (status_ccp || status_beacon) {
      next();
    } else {
      next('/error-400');
    }
  } else {
    next('/login');
  }
});

export default router;
